export default "__VITE_ASSET__CFZTV4EQ__"